<template>
  <div class="profile-complete-page">
    <div class="px30">
      <h2 class="page-title color-text text-25 text-text pt-7 tracking-tight">
        <span class="text-primary">{{ $t("Complete") }}</span>
        <span class="title-black">{{ $t("Your Profile") }}</span>
      </h2>

      <p class="text-center page-subtitle text-12 text-light opacity-60">
        {{ $t("Add your account photo and phone number") }}
      </p>

      <div
        class="sign-up-avatar-container mt-10"
        :class="{ 'avatar-is-required': isAvatar }"
      >
        <PhotoUploader
          :avatar="values.avatar"
          @addAvatar="values.avatar = $event"
          :show-error="false"
        ></PhotoUploader>
        <ul class="formulate-input-errors text-center avatar-required">
          <li
            role="status"
            aria-live="polite"
            class="formulate-input-error text-center"
          >
            {{ $t("Profile picture required") }}
          </li>
        </ul>
      </div>

      <div class="my-10">
        <Telephone clas="telephone" v-model="values.phone" />
      </div>

      <div class="remember-me form-item-row form-item-row_remember">
        <FormulateInput
          v-model="values.agreedTAC"
          type="checkbox"
          id="agreedTAC"
        >
          <template #label="{ label, id }">
            <label :for="id" class="flex items-center">
              <span class="text-lightest_gray text-14 space-x-1">
                {{ $t("By Signing up, you agree to the") }}
                <a class="text-text" href="/terms-of-service">{{
                  $t("Terms of Service")
                }}</a>
                <span>{{ $t("and") }}</span>
                <a class="text-text" href="/privacy-policy">{{
                  $t("Privacy Policy")
                }}</a>
              </span>
            </label>
          </template>
        </FormulateInput>
      </div>

      <div class="form-item-row__btn pr-4">
        <FormulateButton
          :class="{ active: activeBtn }"
          :title="$t('Save')"
          :form-handler="save"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PhotoUploader from "../components/PhotoUploader/PhotoUploader";
import Telephone from "../components/UI/Telephone.vue";
import FormulateButton from "../components/UI/FormulateButton";
import Button from "../components/UI/Button";

export default {
  name: "UserProfile",
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },

  components: {
    PhotoUploader,
    Telephone,
    Button,
    FormulateButton
  },

  created() {
    if (!this.profile) return;
    this.values = {
      ...this.profile
    };
    this.value = this.values.phone;
  },

  data() {
    return {
      phoneNumber: "",
      values: {
        phone: "",
        avatar: "",
        agreedTAC: false
      }
    };
  },

  computed: {
    activeBtn() {
      return this.values.phone && this.values.agreedTAC && this.values.avatar;
    },
    isAvatar() {
      return this.values.phone && this.values.agreedTAC && !this.values.avatar;
    }
  },

  methods: {
    save() {
      if (!this.$user("id")) return;
      this.values.name =
        this.$user("name") ||
        (this.$user("email") && this.$user("email").split("@")[0]);
      this.values.email = this.$user("email");
      this.$emit("phone-verification", this.values);
    }
  }
};
</script>
<style lang="scss">
.profile-complete-page {
  .active button[type="button"] {
    background-color: #db8633;
    cursor: pointer;
    pointer-events: visible;
  }
  .btn-custom {
    .btn {
      background-color: #d8d8d8;
      color: white;
    }
  }
}
</style>
